import React, {Fragment} from 'react';
import {Link} from 'react-router-dom';
import {translate} from 'react-i18next';
import UserButton from './UserButton';
import logo from './images/logo.png';


class Header extends React.PureComponent {

    render() {

        const {t, i18n} = this.props;

        return (

            <Fragment>
                <nav className="navbar navbar-expand-lg border-bottom border-primary border-thick">

                    <button type="button" className={`btn btn-outline-primary d-lg-none ${this.props.filterActive ? 'active' : ''}`} disabled={!this.props.filterControl} onClick={this.props.onFilterClick}>
                        <i className="fas fa-filter fa-fw"/>
                    </button>
                    <Link className="navbar-brand p-0 d-lg-none" to="/"><img src={logo} alt="logo"/></Link>
                    <button type="button" className="btn btn-outline-primary d-lg-none" data-toggle="collapse" data-target="#navbarSupportedContent">
                        <i className="fas fa-bars fa-fw"/>
                    </button>

                    <div className="d-none d-lg-flex w-100">
                        <button type="button" className={`btn btn-outline-primary ${this.props.filterActive ? 'active' : ''}`} disabled={!this.props.filterControl} onClick={this.props.onFilterClick}>
                            <i className="fas fa-filter mr-2"/>
                            <span>{t('header.filter')}</span>
                        </button>
                        <button type="button" className="btn btn-light ml-2" disabled={!this.props.embedControl} onClick={this.props.onEmbedClick}>
                          <i className="fa fa-code fa-fw"/>
                        </button>
                        <Link className="navbar-brand p-0 mx-auto" to="/"><img src={logo} alt="logo"/></Link>
                        <Link className="btn btn-light" to="/camera">
                            <i className="fas fa-camera fa-fw"/>
                        </Link>
                        <button type="button" className="btn btn-light ml-2" onClick={this.props.onInformationClick}>
                            <i className="fas fa-info fa-fw"/>
                        </button>
                        <select className="custom-select h-auto w-auto bg-light border-0 ml-2" value={i18n.language} onChange={(e) => i18n.changeLanguage(e.target.value)}>
                            <option value="nl-NL">NL</option>
                            <option value="en-US">EN</option>
                            <option value="de-DE">DE</option>
                            <option value="fr-FR">FR</option>
                            <option value="hr-HR">HR</option>
                            <option value="lv-LV">LV</option>
                            <option value="mk-MK">MK</option>
                            <option value="uk-UA">UA</option>
                        </select>
                        <UserButton className="ml-2" onClick={this.props.onUserClick}/>
                    </div>

                    <div className="collapse navbar-collapse mw-100" id="navbarSupportedContent">
                        <ul className="navbar-nav mr-auto d-lg-none">
                            <li className="nav-item d-flex pt-2">
                                <button type="button" className="btn btn-light" disabled={!this.props.embedControl} onClick={this.props.onEmbedClick}>
                                    <i className="fas fa-share-alt fa-fw"/>
                                </button>
                                <Link className="btn btn-light ml-auto" to="/camera">
                                    <i className="fas fa-camera fa-fw"/>
                                </Link>
                                <button type="button" className="btn btn-light ml-2" onClick={this.props.onInformationClick}>
                                    <i className="fas fa-info fa-fw"/>
                                </button>
                                <select className="custom-select h-auto w-auto bg-light border-0 ml-2" value={i18n.language} onChange={(e) => i18n.changeLanguage(e.target.value)}>
                                    <option value="nl-NL">NL</option>
                                    <option value="en-US">EN</option>
                                    <option value="de-DE">DE</option>
                                    <option value="fr-FR">FR</option>
                                    <option value="hr-HR">HR</option>
                                    <option value="lv-LV">LV</option>
                                    <option value="mk-MK">MK</option>
                                    <option value="uk-UA">UA</option>
                                </select>
                                <UserButton className="ml-2" onClick={this.props.onUserClick}/>
                            </li>
                        </ul>
                    </div>

                </nav>
            </Fragment>
        );
    }
}

Header.defaultProps = {

    embedControl: true,
    filterControl: true,
};

export default translate()(Header);



// WEBPACK FOOTER //
// ./src/components/Header.js